// kr page
import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { createStore, combineReducers, applyMiddleware} from 'redux';
import {  Provider } from 'react-redux';
import thunkMiddleware from "redux-thunk";
import okrDetailsReducer from "./reducers/goals/okrDetails.reducer";
import CommentsReducers from "./reducers/comments.reducers";
import TeamsPageOkr from "./components/teams.okr.component";
import { CoauthorTeamSummaryComponent } from './components/teams/coauthor-team-summary.component';

const initTeamsPageOkrComp = async function (initialData) {
	const rootReducer = combineReducers({
		CommentsReducers,
		okrDetailsReducer
	});
  	const teamsPageOkrStore = createStore(rootReducer,applyMiddleware(thunkMiddleware));
	ReactDOM.render(
		<Provider store={teamsPageOkrStore}>
			<TeamsPageOkr initialData={initialData} />
		</Provider>,
		document.getElementById('mywobo-teams-okr-tab-wrapper'),
	);
};

initTeamsPageOkrComp.propTypes = {
	initialData: PropTypes.object
};

const initTeamSummaryComp = async function (domId, teamId) {
	ReactDOM.render(
		<CoauthorTeamSummaryComponent teamId={teamId} />,
		document.getElementById(domId)
	);
}


window.initTeamsPageOkrComp = initTeamsPageOkrComp;
window.initTeamSummaryComp = initTeamSummaryComp;
